<template>
  <div>
    <div v-click-outside="config" class="right-bar">
      <div>
        <div class="rightbar-title px-3 py-4">
          <a href="javascript:void(0);" class="right-bar-toggle float-right" @click="hide">
            <i class="mdi mdi-close noti-icon"></i>
          </a>
          <h5 class="m-0">Settings</h5>
        </div>
        <hr class="mt-0" />
        <h6 class="text-center mb-0">Options</h6>
      </div>
    </div>
    <div class="rightbar-overlay"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        handler: this.handleRightBarClick,
        middleware: this.middleware,
      },
    };
  },

  methods: {
    hide() {
      this.$parent.toggleRightSidebar();
    },

    handleRightBarClick() {
      this.$parent.hideRightSidebar();
    },

    middleware(event) {
      return !event.target.classList.contains("toggle-right");
    },
  },
};
</script>
